import { InjectionToken } from '@angular/core';
import { DomainId } from '@config';

export const DOMAIN_ID = new InjectionToken<DomainId>('Domain ID');
